import { SimChoiceInterface } from '../../models/sim-choice.interface';

export interface SimChoiceInterfaceState {
  simChoice: SimChoiceInterface;
}

export const initialSimChoiceState: SimChoiceInterfaceState = {
  simChoice: null
};
